import React, { forwardRef } from 'react'
import { ThemeProvider } from 'styled-components'

import Styled from './Grid.styled'

/**
 * Grid component
 * @param {string} className
 * @param {React.ReactNode} children
 * @param {'recipe-card'|'product-card'} variant
 * @param {12|16|24} gap
 * @param {boolean} centered
 * @param {function} onScroll
 */
const Grid = forwardRef(
  (
    {
      className,
      children,
      onScroll,
      variant,
      gap,
      centered,
      role,
      ariaRoleDescription,
      autoFill,
    },
    ref,
  ) => {
    return (
      <ThemeProvider theme={{ variant, centered, gap }}>
        <Styled
          ref={ref}
          onScroll={onScroll}
          className={className}
          role={role}
          aria-roledescription={ariaRoleDescription}
          autoFill={autoFill}
        >
          {children}
        </Styled>
      </ThemeProvider>
    )
  },
)

Grid.displayName = 'Grid'

Grid.defaultProps = {
  variant: 'recipe-card',
  centered: false,
}

export default Grid
